import mailcheck from "mailcheck";

import { sub } from "@jssrv/template";

import * as hideable  from "../../components/hideable";
import formField      from "../../components/form-field";
import a              from "../../components/anchor";
import formLogo       from "../../components/form-logo";
import loadingSpinner from "../../components/loading-spinner";


import handleForm   from "../../util/handle-form";
import ga           from "../../util/ga";
import { postForm } from "../../util/post-form";

import globalState from "../../state";

import css from "./index.css";

import passthroughParams from "./wait/components/passthrough-params";
import thirdPartyLogin   from "./thirdPartyLogin";

const formI18n  = globalState.i18n.forms.login;
const loginI18n = globalState.i18n.login;

export default {
    oninit({ state }) {
        state.emailSuggestion = "";

        state.fields = {};

        // can't m.route.set() to external links
        if (globalState.redirect && /^http(s):\/\//.test(globalState.redirect)) {
            document.location = globalState.redirect;
        }

        // zendesk JWT login must POST not redirect
        if (globalState.redirect.method === "POST") {
            postForm(globalState.redirect);

            state.posting = true;

            return;
        }

        if (globalState.loggedIn || globalState.redirect) {
            m.route.set(globalState.redirect || "/overview");
        }
    },

    view({ state }) {
        // eslint-disable-next-line align-assignments/align-assignments
        const email = m.route.param("email");
        const features = globalState?.features ?? window?.state?.features ?? {};

        const thirdParties = [ "steam", "epic" ].filter(platform => features[platform]);

        return m("div", {
                    class       : css.loginModule,
                    "data-test" : "loginContainer"
                },

            state.posting ?
                loadingSpinner :
                m("form",
                    handleForm({
                        method : "POST",
                        action : `/login?${m.buildQueryString(state.queryParams)}`,

                        iovation  : features["iovation-login"],
                        recaptcha : features["captcha-login"] && { action : "login" },

                        class : css.loginForm
                    }),

                    // value of this input is used for determining the schema
                    m("input", {
                        type  : "hidden",
                        name  : "_formName",
                        value : "login"
                    }),

                    m(passthroughParams),

                    m("h1.serif",
                        m(formLogo),
                        loginI18n.header
                    ),

                    m(formField, {
                        name         : "email",
                        autocomplete : "username",
                        strings      : formI18n.email,
                        labelClass   : "pure-u-1",
                        autofocus    : true, // for when JS isn't enabled
                        onchange     : m.withAttr("value", value => {
                            const suggestion = mailcheck.run({ email : value });

                            state.emailSuggestion = suggestion ? suggestion.full : "";
                        }),
                        oninput(e) {
                            state.fields.email = e.target.value;
                        }
                    }),

                    m("div",  { class : css.loginEmailSuggestion }, state.emailSuggestion ?
                        m.trust(sub(formI18n.emailSuggestion, { email : state.emailSuggestion })) :
                        null
                    ),

                    m(hideable.input, {
                        name         : "password",
                        autocomplete : "current-password",
                        type         : "password",
                        strings      : formI18n.password,
                        labelClass   : "pure-u-1"
                    }),

                    m("button", {
                            class : css.submit,
                            type  : "submit",

                            onclick() {
                                ga({
                                    event         : "gtm-login",
                                    eventCategory : "login",
                                    eventAction   : "login-click",
                                    eventLabel    : "login"
                                });
                            }
                        },
                        loginI18n.signin
                    )
                ),

                m("p", { class : css.orThirdParty }, m("span", loginI18n.orThirdParty)),

                m("div", { class : css.thirdParties, "data-third-party-count" : thirdParties.length },
                    thirdParties.map(platform => m(thirdPartyLogin, { platform }))
                ),

                m("hr", { class : css.hr }),

                m("div", { class : css.lowerLinks },

                    m(a, {
                        href        : "/register?alt=gw2",
                        "data-test" : "register-link"
                    }, loginI18n.register.linktext),


                    m("span", { class : css.helpLinks },
                        features.passwordReset ?
                            m(a, {
                                    href        : `/password-reset${email ? `?email=${email}` : ""}`,
                                    class       : css.forgot,
                                    "data-test" : "forgot-password"
                                }, loginI18n.forgot.pwReset) :
                            null,

                        m("a", {
                                href        : globalState.get("urls.troubleLoggingIn"),
                                "data-test" : "trouble-logging-in"
                            }, loginI18n.forgot.trouble)
                    )
                )
            );
    }
};
